import $ from 'jquery'

var cookieName = WEBSITE_ID + '_contact_response';
var cookie     = $.cookie(cookieName);
var data       = cookie ? JSON.parse(cookie) : false;

if (data) {
  var $div     = $('.contact_response');
  var divClass = 'Alert--info';
  var message  = 'Errore generico';

  switch (data.msgStatus) {
    case 'error':
      divClass = 'Alert--error';
      message  = data.errors.join('<br>');
      break;
    case 'ok':
      divClass = 'Alert--sucesss';
      message  = data.message;
      break;
  }

  $div.removeClass('u-hidden').addClass(divClass).html(message);
  $('html, body').animate({scrollTop : $div.offset().top - 50}, 500);
  $.removeCookie(cookieName, {path : '/'});
  if (typeof(data.errorfields) !== 'undefined') $.each(data.errorfields, function (k, v) {
    $(':input[name="' + v + '"]').parent().addClass('is-invalid');
  });
}



// WEBPACK FOOTER //
// ./src/themes/pac/js/contact.js